import axios from "axios";
import { DISTRIBUTION_COMPARISON_REPORT, DEDUCTION_COMPARISON_REPORT, SET_ERROR, REPORT_401K } from "../../types";

export const distributionComparisonReport = (params) => {
    return async dispatch => {
        await axios.get(`api/payroll-comparisons/distribution-comparison-report`, { params }).then(res => {
            dispatch({
                type: DISTRIBUTION_COMPARISON_REPORT,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
};

export const deductionComparisonReport = params => {
    return async dispatch => {
        await axios.get('api/payroll-comparisons/deduction-comparison-report', { params }).then(res => {
            dispatch({
                type: DEDUCTION_COMPARISON_REPORT,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
};

export const adjustment401kReport = params => {
    return async dispatch => {
        await axios.get('api/payroll-comparisons/401k-distribution-report', { params }).then(res => {
            dispatch({
                type: REPORT_401K,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
}